import dayjs from 'src/utils/dayjs'

const HAS_TIMEZONE = /([+-]\d{2}:\d{2}|Z)$/

export function isExpired(endTime: string | undefined): boolean {
  if (!endTime) return false
  if (!HAS_TIMEZONE.test(endTime)) return false
  const end = dayjs(endTime)
  if (!end.isValid()) return false
  return !dayjs().isBefore(end)
}
